export default {
  initialExtent: [-8183000, 5047500, -7784300, 5294900],
  maxZoom: 17,
  basemaps: {
    carto: {
      url: 'https://basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
      attributions: '© Carto',
    },
    streets: {
      url: 'https://tiles.arcgis.com/tiles/hGdibHYSPO59RG1h/arcgis/rest/services/MassGIS_Basemap_Detailed_Features/MapServer/tile/{z}/{y}/{x}',
      attributions: '© MassGIS',
    },
    structures: {
      url: 'https://tiles.arcgis.com/tiles/hGdibHYSPO59RG1h/arcgis/rest/services/MassGIS_Structures/MapServer/tile/{z}/{y}/{x}',
    },
    imagery: {
      url: 'https://tiles.arcgis.com/tiles/hGdibHYSPO59RG1h/arcgis/rest/services/orthos2021/MapServer/tile/{z}/{y}/{x}',
      attributions: '© MassGIS',
    },
  },
};
